// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/fonts/roboto/roboto-100.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/fonts/roboto/roboto-300.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/fonts/roboto/roboto-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/fonts/roboto/roboto-500.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/assets/fonts/roboto/roboto-700.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/assets/fonts/roboto/roboto-900.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
  @font-face {
    font-family: Roboto;
    font-weight: 100;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  @font-face {
    font-family: Roboto;
    font-weight: 300;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  @font-face {
    font-family: Roboto;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  @font-face {
    font-family: Roboto;
    font-weight: 500;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  @font-face {
    font-family: Roboto;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  @font-face {
    font-family: Roboto;
    font-weight: 900;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
  .about-content h1 {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
  .about-content h2 {
  font-size: 1.5rem;
  line-height: 2rem;
}
  .about-content h3 {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
  .about-content h4 {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
  .about-content a {
  color: var(--color-info-400);
  text-decoration-line: none;
}
  .about-content a:hover {
  text-decoration-line: underline;
}
  .about-content p {
  font-size: 1rem;
  line-height: 1.5rem;
}
  .about-content u {
  text-decoration-line: underline;
}
  .about-content s {
  text-decoration-line: line-through;
}
  .about-content b {
  font-weight: 700;
}
  .about-content img {
  height: auto;
  max-width: 100%;
  border-radius: 0.5rem;
}
  .about-content table {
  width: 100%;
  table-layout: auto;
}
  .about-content table > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * (1 - 0));
  border-top-width: calc(1px * (1 - var(--tw-divide-y-reverse)));
  border-top-width: calc(1px * calc(1 - 0));
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * 0);
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
  border-color: var(--color-neutral-300);
}
  body {
  font-family: Roboto, sans-serif;
  color: var(--color-neutral-600);
}

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
/* button styles */
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
}
.btn-size-small {
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 12px;
  padding-right: 12px;
}
.btn-size-default {
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
}
.btn-size-large {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;
}
.btn-default {
  background-color: transparent;
  color: var(--color-secondary-500);
}
.btn-default:hover {
  background-color: var(--color-neutral-300);
  color: var(--color-secondary-400);
}
.btn-default:active {
  background-color: var(--color-neutral-200);
  background-color: var(--color-neutral-300);
}
.btn-default:disabled {
  color: var(--color-neutral-400);
}
.btn-outlined {
  border-width: 1px;
  border-color: var(--color-neutral-400);
  background-color: transparent;
  color: var(--color-neutral-500);
}
.btn-outlined:hover {
  background-color: var(--color-neutral-200);
  color: var(--color-secondary-400);
}
.btn-outlined:active {
  background-color: var(--color-neutral-300);
}
.btn-outlined:disabled {
  border-color: var(--color-neutral-300);
  color: var(--color-neutral-400);
}
.btn-secondary {
  border-width: 1px;
  border-color: transparent;
  background-color: var(--color-secondary-500);
  color: var(--color-neutral-100);
}
.btn-secondary:hover {
  background-color: var(--color-secondary-400);
}
.btn-secondary:active {
  background-color: var(--color-secondary-200);
  color: var(--color-neutral-500);
}
.btn-secondary:disabled {
  background-color: var(--color-neutral-300);
  color: var(--color-neutral-400);
}
.btn-secondary-outlined {
  border-width: 1px;
  border-color: var(--color-secondary-500);
  color: var(--color-secondary-500);
}
.btn-secondary-outlined:hover {
  background-color: var(--color-secondary-400);
  color: var(--color-neutral-100);
}
.btn-secondary-outlined:active {
  background-color: var(--color-secondary-500);
  color: var(--color-neutral-100);
}
.btn-secondary-outlined:disabled {
  background-color: var(--color-neutral-300);
  color: var(--color-neutral-400);
}
.btn-primary {
  border-width: 1px;
  border-color: transparent;
  background-color: var(--color-primary-500);
  color: var(--color-neutral-100);
}
.btn-primary:hover {
  background-color: var(--color-primary-400);
}
.btn-primary:active {
  background-color: var(--color-primary-200);
  color: var(--color-neutral-500);
}
.btn-primary:disabled {
  background-color: var(--color-neutral-300);
  color: var(--color-neutral-400);
}
/* tag styles */
.tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-width: 1px;
  border-color: transparent;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
}
.tag-type-default {
  border-radius: 0.375rem;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
  padding-bottom: 1px;
}
.tag-type-rounded {
  border-radius: 1rem;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 1px;
  padding-bottom: 1px;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.sv-scrollbar::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
.sv-scrollbar::-webkit-scrollbar-track {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
  }
.sv-scrollbar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
  }
.sv-scrollbar::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.4);
  }
.sv-scrollbar::-webkit-scrollbar-thumb:active {
    background: rgba(0, 0, 0, 0.9);
  }
.tab-list-parent,
  .active-tab {
  position: relative;
}
.tab-list-parent::after {
    content: '';
    position: absolute;
    left: 0px;
    bottom: 0px;
    height: 1px;
    width: 100%;
    background-color: var(--color-neutral-300);
  }
.tab-list-parent .active-tab::after {
    content: '';
    position: absolute;
    left: 0px;
    bottom: -1px;
    z-index: 10;
    width: 100%;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border-width: 2px;
    border-color: var(--color-primary-500);
  }
.nonactive-tab {
  color: var(--color-neutral-500);
  transition-property: all;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.nonactive-tab:hover {
  background-color: var(--color-neutral-300);
}
.nonactive-tab:active {
  background-color: var(--color-secondary-500);
  color: var(--color-neutral-100);
}
.nonactive-tab {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  border-bottom-width: 1px;
  background-color: var(--color-secondary-100);
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
  color: var(--color-neutral-500);
}
@media (min-width: 768px) {

  .nonactive-tab {
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
.transition-box {
    max-width: 0;
    overflow: hidden;
    opacity: 0;
    transform: translateX(-100%);
    transition-property: max-width, transform, opacity;
    transition-duration: 0.5s, 0s, 0.2s;
    transition-timing-function: ease-out, ease-out, ease-out;
    transition-delay: 0s, 0s, 0.3s;
  }
.transition-box.active {
    max-width: 25%;
    transform: translateX(0);
    opacity: 1;
    transition-delay: 0.2s, 0s, 0s;
  }
@media screen and (max-width: 480px) {
    .transition-box.active {
      max-width: 100%;
    }
  }
.neutral-button {
  color: var(--color-neutral-500);
  transition-property: all;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.neutral-button:hover {
  background-color: var(--color-neutral-300);
}
.neutral-button:active {
  background-color: var(--color-secondary-500);
  color: var(--color-neutral-100);
}
.tooltip {
  position: absolute;
  display: none;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 50px;
  max-width: 250px;
  border-radius: 0.25rem;
  background-color: var(--color-neutral-500);
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 0.75rem;
  line-height: 1rem;
  opacity: 0.2;
  transition-property: opacity;
  transition-duration: 100ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.group:hover .tooltip {
  display: block;
  opacity: 1;
}
.image-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 6px;
    gap: 6px;
    height: 50vh;
    overflow-y: auto;
    border-radius: 10px;
  }
img.selected {
    border: 8px solid #787878; /* A green border */
    box-shadow: 0px 0px 20px 5px #787878; /* Horizontal, Vertical, Blur, Size and color */
    transition:
      box-shadow 0.3s ease-in-out, border 0.3s ease-in-out; /* Smooth transition */
    border-radius: 10px;
  }
/* Styles for the scrollbar itself */
::-webkit-scrollbar {
    width: 7px; /* Adjust width of the scrollbar */
  }
::-webkit-scrollbar-horizontal {
    height: 7px; /* Adjust height of the horizontal scrollbar */
  }
/* Styles for the track (or progress bar) of the scrollbar */
::-webkit-scrollbar-track {
    background: var(--color-neutral-200); /* Color of the track */
    border-radius: 10px; /* Roundness of the track */
  }
/* Styles for the handle (or thumb) of the scrollbar */
::-webkit-scrollbar-thumb {
    background: var(--color-neutral-300); /* Color of the scrollbar handle */
    border-radius: 10px; /* Roundness of the scrollbar handle */
  }
input[type='date']::-webkit-calendar-picker-indicator {
    background: url('https://www.svgrepo.com/show/191998/calendar.svg') no-repeat center center /
      contain;
    width: 35px;
    height: 35px;
    box-sizing: border-box;
  }
.table-container {
  width: 100%;
  overflow-x: auto;
  border-radius: 0.75rem;
  border-width: 1px;
  border-color: var(--color-neutral-300);
  background-color: var(--color-neutral-200);
  padding-bottom: 24px;
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px 0 var(--color-neutral-300), 0 1px 2px -1px var(--color-neutral-300);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
  --tw-shadow-color: var(--color-neutral-300);
  --tw-shadow: var(--tw-shadow-colored);
}
.table-container table {
  width: 100%;
  min-width: 600px;
}
.table-container thead {
  background-color: var(--color-neutral-100);
  padding-left: 12px;
  padding-right: 12px;
}
.table-container thead tr {
  border-bottom-width: 2px;
  border-color: var(--color-neutral-300);
}
.table-container thead th {
  gap: 4px;
  padding: 8px;
  text-align: left;
  color: var(--color-neutral-600);
}
.table-container tbody tr {
  border-bottom-width: 1px;
  border-color: var(--color-neutral-100);
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.table-container tbody tr:hover {
  background-color: var(--color-secondary-100);
}
.table-container tbody td {
  padding: 8px;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-1 {
  bottom: -4px;
}
.-bottom-3 {
  bottom: -12px;
}
.-bottom-5 {
  bottom: -24px;
}
.-right-1 {
  right: -4px;
}
.-right-2 {
  right: -8px;
}
.-right-3 {
  right: -12px;
}
.-top-1 {
  top: -4px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 4px;
}
.bottom-12 {
  bottom: 80px;
}
.bottom-2 {
  bottom: 8px;
}
.bottom-4 {
  bottom: 16px;
}
.bottom-\\[100\\%\\] {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-2\\/4 {
  left: 50%;
}
.left-3\\/4 {
  left: 75%;
}
.left-4 {
  left: 16px;
}
.left-full {
  left: 100%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 4px;
}
.right-2 {
  right: 8px;
}
.right-3 {
  right: 12px;
}
.right-4 {
  right: 16px;
}
.right-5 {
  right: 24px;
}
.right-\\[-4px\\] {
  right: -4px;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 4px;
}
.top-2 {
  top: 8px;
}
.top-2\\/4 {
  top: 50%;
}
.top-4 {
  top: 16px;
}
.top-5 {
  top: 24px;
}
.top-6 {
  top: 32px;
}
.top-7 {
  top: 40px;
}
.top-\\[-4px\\] {
  top: -4px;
}
.top-\\[0px\\] {
  top: 0px;
}
.top-\\[140px\\] {
  top: 140px;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-5 {
  grid-column: span 5 / span 5;
}
.row-span-1 {
  grid-row: span 1 / span 1;
}
.row-span-2 {
  grid-row: span 2 / span 2;
}
.m-2 {
  margin: 8px;
}
.m-5 {
  margin: 24px;
}
.m-auto {
  margin: auto;
}
.mx-4 {
  margin-left: 16px;
  margin-right: 16px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 8px;
  margin-bottom: 8px;
}
.my-6 {
  margin-top: 32px;
  margin-bottom: 32px;
}
.-ml-3 {
  margin-left: -12px;
}
.-mr-2 {
  margin-right: -8px;
}
.-mt-13 {
  margin-top: -88px;
}
.-mt-2 {
  margin-top: -8px;
}
.mb-1 {
  margin-bottom: 4px;
}
.mb-10 {
  margin-bottom: 68px;
}
.mb-11 {
  margin-bottom: 72px;
}
.mb-2 {
  margin-bottom: 8px;
}
.mb-3 {
  margin-bottom: 12px;
}
.mb-4 {
  margin-bottom: 16px;
}
.mb-5 {
  margin-bottom: 24px;
}
.mb-6 {
  margin-bottom: 32px;
}
.mb-7 {
  margin-bottom: 40px;
}
.mb-\\[25px\\] {
  margin-bottom: 25px;
}
.ml-1 {
  margin-left: 4px;
}
.ml-12 {
  margin-left: 80px;
}
.ml-2 {
  margin-left: 8px;
}
.ml-3 {
  margin-left: 12px;
}
.ml-4 {
  margin-left: 16px;
}
.ml-5 {
  margin-left: 24px;
}
.ml-7 {
  margin-left: 40px;
}
.ml-\\[78px\\] {
  margin-left: 78px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 4px;
}
.mr-12 {
  margin-right: 80px;
}
.mr-2 {
  margin-right: 8px;
}
.mr-3 {
  margin-right: 12px;
}
.mr-4 {
  margin-right: 16px;
}
.mr-5 {
  margin-right: 24px;
}
.mr-auto {
  margin-right: auto;
}
.mt-1 {
  margin-top: 4px;
}
.mt-2 {
  margin-top: 8px;
}
.mt-3 {
  margin-top: 12px;
}
.mt-4 {
  margin-top: 16px;
}
.mt-5 {
  margin-top: 24px;
}
.mt-6 {
  margin-top: 32px;
}
.mt-\\[70px\\] {
  margin-top: 70px;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-4 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.inline-grid {
  display: inline-grid;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-1 {
  height: 4px;
}
.h-10 {
  height: 68px;
}
.h-2 {
  height: 8px;
}
.h-3 {
  height: 12px;
}
.h-4 {
  height: 16px;
}
.h-5 {
  height: 24px;
}
.h-6 {
  height: 32px;
}
.h-7 {
  height: 40px;
}
.h-8 {
  height: 48px;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[115px\\] {
  height: 115px;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[123px\\] {
  height: 123px;
}
.h-\\[145px\\] {
  height: 145px;
}
.h-\\[148px\\] {
  height: 148px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[225px\\] {
  height: 225px;
}
.h-\\[226px\\] {
  height: 226px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[calc\\(100vh-148px\\)\\] {
  height: calc(100vh - 148px);
}
.h-\\[calc\\(100vh-90px\\)\\] {
  height: calc(100vh - 90px);
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-14 {
  max-height: 96px;
}
.max-h-8 {
  max-height: 48px;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[350px\\] {
  max-height: 350px;
}
.max-h-\\[5rem\\] {
  max-height: 5rem;
}
.max-h-\\[60px\\] {
  max-height: 60px;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[30px\\] {
  min-height: 30px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-full {
  min-height: 100%;
}
.w-0 {
  width: 0px;
}
.w-1 {
  width: 4px;
}
.w-10 {
  width: 68px;
}
.w-14 {
  width: 96px;
}
.w-2 {
  width: 8px;
}
.w-20 {
  width: 144px;
}
.w-3 {
  width: 12px;
}
.w-4 {
  width: 16px;
}
.w-4\\/5 {
  width: 80%;
}
.w-5 {
  width: 24px;
}
.w-6 {
  width: 32px;
}
.w-7 {
  width: 40px;
}
.w-8 {
  width: 48px;
}
.w-\\[10px\\] {
  width: 10px;
}
.w-\\[11rem\\] {
  width: 11rem;
}
.w-\\[12rem\\] {
  width: 12rem;
}
.w-\\[14px\\] {
  width: 14px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[20xp\\] {
  width: 20xp;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[38px\\] {
  width: 38px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[420px\\] {
  width: 420px;
}
.w-\\[44px\\] {
  width: 44px;
}
.w-\\[470px\\] {
  width: 470px;
}
.w-\\[72px\\] {
  width: 72px;
}
.w-\\[8rem\\] {
  width: 8rem;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.min-w-6 {
  min-width: 32px;
}
.min-w-\\[1000px\\] {
  min-width: 1000px;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[600px\\] {
  min-width: 600px;
}
.min-w-\\[70px\\] {
  min-width: 70px;
}
.min-w-\\[800px\\] {
  min-width: 800px;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.max-w-\\[1000px\\] {
  max-width: 1000px;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[10rem\\] {
  max-width: 10rem;
}
.max-w-\\[1200px\\] {
  max-width: 1200px;
}
.max-w-\\[12rem\\] {
  max-width: 12rem;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[1600px\\] {
  max-width: 1600px;
}
.max-w-\\[1700px\\] {
  max-width: 1700px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[20rem\\] {
  max-width: 20rem;
}
.max-w-\\[25\\%\\] {
  max-width: 25%;
}
.max-w-\\[30rem\\] {
  max-width: 30rem;
}
.max-w-\\[40rem\\] {
  max-width: 40rem;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[6rem\\] {
  max-width: 6rem;
}
.max-w-\\[75\\%\\] {
  max-width: 75%;
}
.max-w-\\[8rem\\] {
  max-width: 8rem;
}
.max-w-\\[90px\\] {
  max-width: 90px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.basis-full {
  flex-basis: 100%;
}
.table-auto {
  table-layout: auto;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2\\/4 {
  --tw-translate-x: -50%;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\/4 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[21px\\] {
  --tw-translate-x: 21px;
  transform: translate(21px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[3px\\] {
  --tw-translate-x: 3px;
  transform: translate(3px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(-90deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(90deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.95) scaleY(.95);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-all {
  -webkit-user-select: all;
     -moz-user-select: all;
          user-select: all;
}
.resize {
  resize: both;
}
.grid-flow-col {
  grid-auto-flow: column;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 4px;
}
.gap-2 {
  gap: 8px;
}
.gap-3 {
  gap: 12px;
}
.gap-4 {
  gap: 16px;
}
.gap-5 {
  gap: 24px;
}
.gap-6 {
  gap: 32px;
}
.gap-7 {
  gap: 40px;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[6px\\] {
  gap: 6px;
}
.gap-y-3 {
  row-gap: 12px;
}
.gap-y-4 {
  row-gap: 16px;
}
.-space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-16px * 0);
  margin-right: calc(-16px * var(--tw-space-x-reverse));
  margin-left: calc(-16px * (1 - 0));
  margin-left: calc(-16px * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(-16px * calc(1 - 0));
  margin-left: calc(-16px * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(4px * (1 - 0));
  margin-top: calc(4px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(4px * calc(1 - 0));
  margin-top: calc(4px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(4px * 0);
  margin-bottom: calc(4px * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(8px * (1 - 0));
  margin-top: calc(8px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(8px * calc(1 - 0));
  margin-top: calc(8px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(8px * 0);
  margin-bottom: calc(8px * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(12px * (1 - 0));
  margin-top: calc(12px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(12px * calc(1 - 0));
  margin-top: calc(12px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(12px * 0);
  margin-bottom: calc(12px * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(16px * (1 - 0));
  margin-top: calc(16px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(16px * calc(1 - 0));
  margin-top: calc(16px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(16px * 0);
  margin-bottom: calc(16px * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(24px * (1 - 0));
  margin-top: calc(24px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(24px * calc(1 - 0));
  margin-top: calc(24px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(24px * 0);
  margin-bottom: calc(24px * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(32px * (1 - 0));
  margin-top: calc(32px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(32px * calc(1 - 0));
  margin-top: calc(32px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(32px * 0);
  margin-bottom: calc(32px * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * (1 - 0));
  border-top-width: calc(1px * (1 - var(--tw-divide-y-reverse)));
  border-top-width: calc(1px * calc(1 - 0));
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * 0);
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-clip {
  text-overflow: clip;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  word-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-2xl {
  border-bottom-left-radius: 1rem;
}
.rounded-bl-lg {
  border-bottom-left-radius: 0.5rem;
}
.rounded-tl {
  border-top-left-radius: 0.25rem;
}
.rounded-tl-2xl {
  border-top-left-radius: 1rem;
}
.rounded-tl-none {
  border-top-left-radius: 0px;
}
.rounded-tr {
  border-top-right-radius: 0.25rem;
}
.rounded-tr-none {
  border-top-right-radius: 0px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-dotted {
  border-style: dotted;
}
.border-\\[neutral-100\\] {
  border-color: neutral-100;
}
.border-\\[white\\] {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
.border-functional-danger-400 {
  border-color: var(--color-danger-400);
}
.border-functional-danger-dark {
  border-color: var(--color-danger-dark);
}
.border-functional-info-400 {
  border-color: var(--color-info-400);
}
.border-functional-info-dark {
  border-color: var(--color-info-dark);
}
.border-functional-success-dark {
  border-color: var(--color-success-dark);
}
.border-neutral-100 {
  border-color: var(--color-neutral-100);
}
.border-neutral-200 {
  border-color: var(--color-neutral-200);
}
.border-neutral-300 {
  border-color: var(--color-neutral-300);
}
.border-neutral-400 {
  border-color: var(--color-neutral-400);
}
.border-neutral-500 {
  border-color: var(--color-neutral-500);
}
.border-primary-300 {
  border-color: var(--color-primary-300);
}
.border-primary-400 {
  border-color: var(--color-primary-400);
}
.border-primary-500 {
  border-color: var(--color-primary-500);
}
.border-secondary-100 {
  border-color: var(--color-secondary-100);
}
.border-secondary-200 {
  border-color: var(--color-secondary-200);
}
.border-secondary-500 {
  border-color: var(--color-secondary-500);
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
.border-t-functional-info-dark {
  border-top-color: var(--color-info-dark);
}
.bg-\\[transparent\\] {
  background-color: transparent;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, 1);
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}
.bg-functional-danger-400 {
  background-color: var(--color-danger-400);
}
.bg-functional-danger-dark {
  background-color: var(--color-danger-dark);
}
.bg-functional-danger-light {
  background-color: var(--color-danger-light);
}
.bg-functional-info-dark {
  background-color: var(--color-info-dark);
}
.bg-functional-info-light {
  background-color: var(--color-info-light);
}
.bg-functional-success-dark {
  background-color: var(--color-success-dark);
}
.bg-functional-success-light {
  background-color: var(--color-success-light);
}
.bg-functional-warning-light {
  background-color: var(--color-warning-light);
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 114, 128, 1);
  background-color: rgba(107, 114, 128, var(--tw-bg-opacity));
}
.bg-neutral-100 {
  background-color: var(--color-neutral-100);
}
.bg-neutral-200 {
  background-color: var(--color-neutral-200);
}
.bg-neutral-300 {
  background-color: var(--color-neutral-300);
}
.bg-neutral-400 {
  background-color: var(--color-neutral-400);
}
.bg-neutral-500 {
  background-color: var(--color-neutral-500);
}
.bg-neutral-600 {
  background-color: var(--color-neutral-600);
}
.bg-primary-200 {
  background-color: var(--color-primary-200);
}
.bg-primary-300 {
  background-color: var(--color-primary-300);
}
.bg-secondary-100 {
  background-color: var(--color-secondary-100);
}
.bg-secondary-200 {
  background-color: var(--color-secondary-200);
}
.bg-secondary-400 {
  background-color: var(--color-secondary-400);
}
.bg-secondary-500 {
  background-color: var(--color-secondary-500);
}
.bg-secondary-600 {
  background-color: var(--color-secondary-600);
}
.bg-transparent {
  background-color: transparent;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-65 {
  --tw-bg-opacity: 0.65;
}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.object-center {
  -o-object-position: center;
     object-position: center;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 4px;
}
.p-2 {
  padding: 8px;
}
.p-3 {
  padding: 12px;
}
.p-4 {
  padding: 16px;
}
.p-5 {
  padding: 24px;
}
.p-\\[2px\\] {
  padding: 2px;
}
.p-\\[6px\\] {
  padding: 6px;
}
.p-\\[7px\\] {
  padding: 7px;
}
.p-\\[8px\\] {
  padding: 8px;
}
.px-1 {
  padding-left: 4px;
  padding-right: 4px;
}
.px-10 {
  padding-left: 68px;
  padding-right: 68px;
}
.px-2 {
  padding-left: 8px;
  padding-right: 8px;
}
.px-3 {
  padding-left: 12px;
  padding-right: 12px;
}
.px-4 {
  padding-left: 16px;
  padding-right: 16px;
}
.px-5 {
  padding-left: 24px;
  padding-right: 24px;
}
.px-6 {
  padding-left: 32px;
  padding-right: 32px;
}
.px-7 {
  padding-left: 40px;
  padding-right: 40px;
}
.px-8 {
  padding-left: 48px;
  padding-right: 48px;
}
.px-\\[14px\\] {
  padding-left: 14px;
  padding-right: 14px;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.py-1 {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-10 {
  padding-top: 68px;
  padding-bottom: 68px;
}
.py-2 {
  padding-top: 8px;
  padding-bottom: 8px;
}
.py-3 {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-4 {
  padding-top: 16px;
  padding-bottom: 16px;
}
.py-5 {
  padding-top: 24px;
  padding-bottom: 24px;
}
.py-6 {
  padding-top: 32px;
  padding-bottom: 32px;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[11px\\] {
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[80px\\] {
  padding-top: 80px;
  padding-bottom: 80px;
}
.pb-10 {
  padding-bottom: 68px;
}
.pb-2 {
  padding-bottom: 8px;
}
.pb-3 {
  padding-bottom: 12px;
}
.pb-4 {
  padding-bottom: 16px;
}
.pb-5 {
  padding-bottom: 24px;
}
.pb-6 {
  padding-bottom: 32px;
}
.pb-7 {
  padding-bottom: 40px;
}
.pb-8 {
  padding-bottom: 48px;
}
.pb-\\[120px\\] {
  padding-bottom: 120px;
}
.pl-1 {
  padding-left: 4px;
}
.pl-4 {
  padding-left: 16px;
}
.pr-2 {
  padding-right: 8px;
}
.pr-4 {
  padding-right: 16px;
}
.pr-7 {
  padding-right: 40px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 4px;
}
.pt-2 {
  padding-top: 8px;
}
.pt-3 {
  padding-top: 12px;
}
.pt-4 {
  padding-top: 16px;
}
.pt-5 {
  padding-top: 24px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.align-middle {
  vertical-align: middle;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-8xl {
  font-size: 6rem;
  line-height: 1;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-9 {
  line-height: 2.25rem;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.leading-\\[26px\\] {
  line-height: 26px;
}
.leading-\\[30px\\] {
  line-height: 30px;
}
.leading-none {
  line-height: 1;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.text-functional-danger-400 {
  color: var(--color-danger-400);
}
.text-functional-danger-dark {
  color: var(--color-danger-dark);
}
.text-functional-info-400 {
  color: var(--color-info-400);
}
.text-functional-info-dark {
  color: var(--color-info-dark);
}
.text-functional-success-400 {
  color: var(--color-success-400);
}
.text-functional-success-dark {
  color: var(--color-success-dark);
}
.text-functional-warning-dark {
  color: var(--color-warning-dark);
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.text-neutral-100 {
  color: var(--color-neutral-100);
}
.text-neutral-200 {
  color: var(--color-neutral-200);
}
.text-neutral-300 {
  color: var(--color-neutral-300);
}
.text-neutral-400 {
  color: var(--color-neutral-400);
}
.text-neutral-500 {
  color: var(--color-neutral-500);
}
.text-neutral-600 {
  color: var(--color-neutral-600);
}
.text-primary-400 {
  color: var(--color-primary-400);
}
.text-primary-500 {
  color: var(--color-primary-500);
}
.text-secondary-400 {
  color: var(--color-secondary-400);
}
.text-secondary-500 {
  color: var(--color-secondary-500);
}
.text-secondary-600 {
  color: var(--color-secondary-600);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-75 {
  opacity: 0.75;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-neutral-200 {
  --tw-shadow-color: var(--color-neutral-200);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-neutral-300 {
  --tw-shadow-color: var(--color-neutral-300);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline-0 {
  outline-width: 0px;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
body {
  background-color: var(--color-neutral-100); /* Default background color */
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.05) scaleY(1.05);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.1) scaleY(1.1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-primary-200:hover {
  border-color: var(--color-primary-200);
}
.hover\\:border-primary-500:hover {
  border-color: var(--color-primary-500);
}
.hover\\:bg-functional-danger-light:hover {
  background-color: var(--color-danger-light);
}
.hover\\:bg-neutral-100:hover {
  background-color: var(--color-neutral-100);
}
.hover\\:bg-neutral-200:hover {
  background-color: var(--color-neutral-200);
}
.hover\\:bg-neutral-300:hover {
  background-color: var(--color-neutral-300);
}
.hover\\:bg-neutral-400:hover {
  background-color: var(--color-neutral-400);
}
.hover\\:bg-secondary-200:hover {
  background-color: var(--color-secondary-200);
}
.hover\\:bg-secondary-400:hover {
  background-color: var(--color-secondary-400);
}
.hover\\:text-functional-danger-dark:hover {
  color: var(--color-danger-dark);
}
.hover\\:text-functional-info-400:hover {
  color: var(--color-info-400);
}
.hover\\:text-functional-info-dark:hover {
  color: var(--color-info-dark);
}
.hover\\:text-secondary-100:hover {
  color: var(--color-secondary-100);
}
.hover\\:text-secondary-400:hover {
  color: var(--color-secondary-400);
}
.hover\\:text-secondary-500:hover {
  color: var(--color-secondary-500);
}
.hover\\:text-secondary-600:hover {
  color: var(--color-secondary-600);
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.focus\\:ring-primary-500:focus {
  --tw-ring-color: var(--color-primary-500);
}
.active\\:border-primary-200:active {
  border-color: var(--color-primary-200);
}
.active\\:bg-neutral-400:active {
  background-color: var(--color-neutral-400);
}
.active\\:bg-neutral-500:active {
  background-color: var(--color-neutral-500);
}
.active\\:text-functional-danger-dark:active {
  color: var(--color-danger-dark);
}
.active\\:text-functional-info-dark:active {
  color: var(--color-info-dark);
}
.active\\:text-neutral-100:active {
  color: var(--color-neutral-100);
}
.active\\:text-secondary-400:active {
  color: var(--color-secondary-400);
}
.active\\:text-secondary-500:active {
  color: var(--color-secondary-500);
}
.group:hover .group-hover\\:block {
  display: block;
}
.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.1) scaleY(1.1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
@media (min-width: 640px) {

  .sm\\:p-3 {
    padding: 12px;
  }

  .sm\\:pb-9 {
    padding-bottom: 56px;
  }

  .sm\\:duration-700 {
    transition-duration: 700ms;
  }
}
@media (min-width: 768px) {

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-4 {
    height: 16px;
  }

  .md\\:h-\\[200px\\] {
    height: 200px;
  }

  .md\\:h-\\[250px\\] {
    height: 250px;
  }

  .md\\:h-\\[268px\\] {
    height: 268px;
  }

  .md\\:h-\\[275px\\] {
    height: 275px;
  }

  .md\\:h-\\[calc\\(100vh-50px\\)\\] {
    height: calc(100vh - 50px);
  }

  .md\\:h-\\[calc\\(100vh-60px\\)\\] {
    height: calc(100vh - 60px);
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:w-3\\/4 {
    width: 75%;
  }

  .md\\:w-4 {
    width: 16px;
  }

  .md\\:w-\\[200px\\] {
    width: 200px;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:w-\\[calc\\(100\\%-104px\\)\\] {
    width: calc(100% - 104px);
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:basis-auto {
    flex-basis: auto;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\\:gap-6 {
    gap: 32px;
  }

  .md\\:break-words {
    word-wrap: break-word;
  }

  .md\\:p-5 {
    padding: 24px;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-3 {
    padding-left: 12px;
    padding-right: 12px;
  }

  .md\\:px-4 {
    padding-left: 16px;
    padding-right: 16px;
  }

  .md\\:px-5 {
    padding-left: 24px;
    padding-right: 24px;
  }

  .md\\:px-6 {
    padding-left: 32px;
    padding-right: 32px;
  }

  .md\\:py-2 {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .md\\:py-4 {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .md\\:pb-0 {
    padding-bottom: 0px;
  }

  .md\\:pb-5 {
    padding-bottom: 24px;
  }

  .md\\:pl-6 {
    padding-left: 32px;
  }
}
@media (min-width: 769px) {

  .lg\\:absolute {
    position: absolute;
  }

  .lg\\:sticky {
    position: sticky;
  }

  .lg\\:right-0 {
    right: 0px;
  }

  .lg\\:top-0 {
    top: 0px;
  }

  .lg\\:top-\\[0px\\] {
    top: 0px;
  }

  .lg\\:top-\\[40px\\] {
    top: 40px;
  }

  .lg\\:top-\\[41px\\] {
    top: 41px;
  }

  .lg\\:top-\\[48px\\] {
    top: 48px;
  }

  .lg\\:top-\\[50px\\] {
    top: 50px;
  }

  .lg\\:top-\\[51px\\] {
    top: 51px;
  }

  .lg\\:top-\\[85px\\] {
    top: 85px;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:ml-10 {
    margin-left: 68px;
  }

  .lg\\:mr-10 {
    margin-right: 68px;
  }

  .lg\\:mr-5 {
    margin-right: 24px;
  }

  .lg\\:mt-5 {
    margin-top: 24px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:w-\\[calc\\(100\\%-223\\.27px\\)\\] {
    width: calc(100% - 223.27px);
  }

  .lg\\:w-\\[calc\\(90vw\\)\\] {
    width: calc(90vw);
  }

  .lg\\:max-w-\\[1000px\\] {
    max-width: 1000px;
  }

  .lg\\:max-w-\\[900px\\] {
    max-width: 900px;
  }

  .lg\\:basis-auto {
    flex-basis: auto;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:px-5 {
    padding-left: 24px;
    padding-right: 24px;
  }

  .lg\\:px-7 {
    padding-left: 40px;
    padding-right: 40px;
  }

  .lg\\:px-\\[150px\\] {
    padding-left: 150px;
    padding-right: 150px;
  }

  .lg\\:py-4 {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .lg\\:opacity-0 {
    opacity: 0;
  }

  .group:hover .lg\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
}
@media (min-width: 1024px) {

  .xl\\:order-none {
    order: 0;
  }

  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:w-3\\/5 {
    width: 60%;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:items-center {
    align-items: center;
  }

  .xl\\:justify-between {
    justify-content: space-between;
  }

  .xl\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
}
@media (min-width: 1536px) {

  .xxl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,8LAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,0BAAc;EAAd,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,mBAAc;IAAd,gBAAc;IAAd,4CAAc;EAAA;EAAd;IAAA,mBAAc;IAAd,gBAAc;IAAd,4CAAc;EAAA;EAAd;IAAA,mBAAc;IAAd,gBAAc;IAAd,4CAAc;EAAA;EAAd;IAAA,mBAAc;IAAd,gBAAc;IAAd,4CAAc;EAAA;EAAd;IAAA,mBAAc;IAAd,gBAAc;IAAd,4CAAc;EAAA;EAAd;IAAA,mBAAc;IAAd,gBAAc;IAAd,4CAAc;EAAA;EAAd;EAAA,mBAAc;EAAd;AAAc;EAAd;EAAA,iBAAc;EAAd;AAAc;EAAd;EAAA,kBAAc;EAAd;AAAc;EAAd;EAAA,mBAAc;EAAd;AAAc;EAAd;EAAA,4BAAc;EAAd;AAAc;EAAd;EAAA;AAAc;EAAd;EAAA,eAAc;EAAd;AAAc;EAAd;EAAA;AAAc;EAAd;EAAA;AAAc;EAAd;EAAA;AAAc;EAAd;EAAA,YAAc;EAAd,eAAc;EAAd;AAAc;EAAd;EAAA,WAAc;EAAd;AAAc;EAAd;EAAA,wBAAc;EAAd,qCAAc;EAAd,8DAAc;EAAd,yCAAc;EAAd,kEAAc;EAAd,kCAAc;EAAd,2DAAc;EAAd;AAAc;EAAd;EAAA,+BAAc;EAAd;AAAc;;EAAd;;IAAA,wBAAc;IAAd,SAAc;EAAA;EAAd;IAAA,0BAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAuFZ,kBAAkB;AAEhB;EAAA,aAAsF;EAAtF,mBAAsF;EAAtF,uBAAsF;EAAtF,QAAsF;EAAtF,qBAAsF;EAAtF,mBAAsF;EAAtF,gBAAsF;EAAtF;AAAsF;AAGtF;EAAA,gBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAGpB;EAAA,gBAAyB;EAAzB,mBAAyB;EAAzB,kBAAyB;EAAzB;AAAyB;AAGzB;EAAA,gBAAyB;EAAzB,mBAAyB;EAAzB,kBAAyB;EAAzB;AAAyB;AAGzB;EAAA,6BAA4J;EAA5J;AAA4J;AAA5J;EAAA,0CAA4J;EAA5J;AAA4J;AAA5J;EAAA,0CAA4J;EAA5J;AAA4J;AAA5J;EAAA;AAA4J;AAG5J;EAAA,iBAA0L;EAA1L,sCAA0L;EAA1L,6BAA0L;EAA1L;AAA0L;AAA1L;EAAA,0CAA0L;EAA1L;AAA0L;AAA1L;EAAA;AAA0L;AAA1L;EAAA,sCAA0L;EAA1L;AAA0L;AAG1L;EAAA,iBAA2L;EAA3L,yBAA2L;EAA3L,4CAA2L;EAA3L;AAA2L;AAA3L;EAAA;AAA2L;AAA3L;EAAA,4CAA2L;EAA3L;AAA2L;AAA3L;EAAA,0CAA2L;EAA3L;AAA2L;AAG3L;EAAA,iBAAqM;EAArM,wCAAqM;EAArM;AAAqM;AAArM;EAAA,4CAAqM;EAArM;AAAqM;AAArM;EAAA,4CAAqM;EAArM;AAAqM;AAArM;EAAA,0CAAqM;EAArM;AAAqM;AAGrM;EAAA,iBAAqL;EAArL,yBAAqL;EAArL,0CAAqL;EAArL;AAAqL;AAArL;EAAA;AAAqL;AAArL;EAAA,0CAAqL;EAArL;AAAqL;AAArL;EAAA,0CAAqL;EAArL;AAAqL;AAGvL,eAAe;AAEb;EAAA,oBAAkG;EAAlG,mBAAkG;EAAlG,uBAAkG;EAAlG,QAAkG;EAAlG,iBAAkG;EAAlG,yBAAkG;EAAlG,kBAAkG;EAAlG,iBAAkG;EAAlG;AAAkG;AAGlG;EAAA,uBAA+B;EAA/B,iBAA+B;EAA/B,kBAA+B;EAA/B,gBAA+B;EAA/B;AAA+B;AAG/B;EAAA,mBAAgC;EAAhC,iBAAgC;EAAhC,kBAAgC;EAAhC,gBAAgC;EAAhC;AAAgC;AAGlC,gDAAgD;AAChD;IACE,UAAU;IACV,WAAW;EACb;AACA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;AACA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;AACA;IACE,8BAA8B;EAChC;AACA;IACE,8BAA8B;EAChC;AAGE;;EAAA;AAAe;AAEjB;IACE,WAAW;IACX,kBAA6D;IAA7D,SAA6D;IAA7D,WAA6D;IAA7D,WAA6D;IAA7D,WAA6D;IAA7D,0CAA6D;EAC/D;AACA;IACE,WAAW;IACX,kBAAyF;IAAzF,SAAyF;IAAzF,YAAyF;IAAzF,WAAyF;IAAzF,WAAyF;IAAzF,8BAAyF;IAAzF,+BAAyF;IAAzF,iBAAyF;IAAzF,sCAAyF;EAC3F;AAEE;EAAA,+BAA6G;EAA7G,wBAA6G;EAA7G,0BAA6G;EAA7G;AAA6G;AAA7G;EAAA;AAA6G;AAA7G;EAAA,4CAA6G;EAA7G;AAA6G;AAA7G;EAAA,8BAA6G;EAA7G,+BAA6G;EAA7G,wBAA6G;EAA7G,4CAA6G;EAA7G,kBAA6G;EAA7G,mBAA6G;EAA7G,gBAA6G;EAA7G,mBAA6G;EAA7G;AAA6G;AAA7G;;EAAA;IAAA,kBAA6G;IAA7G,mBAA6G;IAA7G,gBAA6G;IAA7G;EAA6G;AAAA;AAG/G;IACE,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,4BAA4B;IAC5B,kDAAkD;IAClD,mCAAmC;IACnC,wDAAwD;IACxD,8BAA8B;EAChC;AAEA;IACE,cAAc;IACd,wBAAwB;IACxB,UAAU;IACV,8BAA8B;EAChC;AAEA;IACE;MACE,eAAe;IACjB;EACF;AAGE;EAAA,+BAAoI;EAApI,wBAAoI;EAApI,0BAAoI;EAApI;AAAoI;AAApI;EAAA;AAAoI;AAApI;EAAA,4CAAoI;EAApI;AAAoI;AAIpI;EAAA,kBAAiM;EAAjM,aAAiM;EAAjM,uBAAiM;EAAjM,kBAAiM;EAAjM,eAAiM;EAAjM,gBAAiM;EAAjM,sBAAiM;EAAjM,0CAAiM;EAAjM,iBAAiM;EAAjM,kBAAiM;EAAjM,gBAAiM;EAAjM,mBAAiM;EAAjM,kBAAiM;EAAjM,iBAAiM;EAAjM,YAAiM;EAAjM,4BAAiM;EAAjM,0BAAiM;EAAjM;AAAiM;AAAjM;EAAA,cAAiM;EAAjM;AAAiM;AAGnM;IACE,aAAa;IACb,qCAAqC;IACrC,aAAQ;IAAR,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;AAEA;IACE,yBAAyB,EAAE,mBAAmB;IAC9C,oCAAoC,EAAE,+CAA+C;IACrF;0DAEyB,EAAE,sBAAsB;IACjD,mBAAmB;EACrB;AA+BA,oCAAoC;AACpC;IACE,UAAU,EAAE,kCAAkC;EAChD;AACA;IACE,WAAW,EAAE,8CAA8C;EAC7D;AAEA,4DAA4D;AAC5D;IACE,oCAAoC,EAAE,uBAAuB;IAC7D,mBAAmB,EAAE,2BAA2B;EAClD;AAEA,sDAAsD;AACtD;IACE,oCAAoC,EAAE,kCAAkC;IACxE,mBAAmB,EAAE,sCAAsC;EAC7D;AAEA;IACE;aACS;IACT,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;AArDI;EAAA,WAAgH;EAAhH,gBAAgH;EAAhH,sBAAgH;EAAhH,iBAAgH;EAAhH,sCAAgH;EAAhH,0CAAgH;EAAhH,oBAAgH;EAAhH,8EAAgH;EAAhH,8FAAgH;EAAhH,+HAAgH;EAAhH,uHAAgH;EAAhH,2CAAgH;EAAhH;AAAgH;AAIhH;EAAA,WAA2B;EAA3B;AAA2B;AAI3B;EAAA,0CAA0B;EAA1B,kBAA0B;EAA1B;AAA0B;AAI1B;EAAA,wBAAoC;EAApC;AAAoC;AAIpC;EAAA,QAA2C;EAA3C,YAA2C;EAA3C,gBAA2C;EAA3C;AAA2C;AAI3C;EAAA,wBAAmE;EAAnE,sCAAmE;EAAnE,kBAAmE;EAAnE,mBAAmE;EAAnE,gBAAmE;EAAnE;AAAmE;AAAnE;EAAA;AAAmE;AAGnE;EAAA;AAAU;AA3OhB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qLAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qLAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,oLAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB,+JAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,mKAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,6BAAmB;EAAnB,qDAAmB;EAAnB,kCAAmB;EAAnB,0DAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+BAAmB;EAAnB,uDAAmB;EAAnB,mCAAmB;EAAnB,2DAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+BAAmB;EAAnB,uDAAmB;EAAnB,mCAAmB;EAAnB,2DAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gCAAmB;EAAnB,wDAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gCAAmB;EAAnB,wDAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gCAAmB;EAAnB,wDAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gCAAmB;EAAnB,wDAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,qCAAmB;EAAnB,8DAAmB;EAAnB,yCAAmB;EAAnB,kEAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA,0BAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,8FAAmB;EAAnB,mHAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,mGAAmB;EAAnB,wHAAmB;EAAnB;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB,iGAAmB;EAAnB,sHAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB,iFAAmB;EAAnB;AAAmB;AAAnB;EAAA,oFAAmB;EAAnB,oGAAmB;EAAnB,yHAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAEnB;EACE,0CAA0C,EAAE,6BAA6B;AAC3E;AANA;EAAA,kBA6QA;EA7QA,kBA6QA;EA7QA,qKA6QA;EA7QA;AA6QA;AA7QA;EAAA,iBA6QA;EA7QA,iBA6QA;EA7QA,mKA6QA;EA7QA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA,mFA6QA;EA7QA,mGA6QA;EA7QA,wHA6QA;EA7QA;AA6QA;AA7QA;EAAA,oFA6QA;EA7QA,oGA6QA;EA7QA,yHA6QA;EA7QA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA,iBA6QA;EA7QA,iBA6QA;EA7QA,mKA6QA;EA7QA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;;EAAA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;AAAA;AA7QA;;EAAA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA,iBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,kBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,kBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,kBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,kBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,gBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,iBA6QA;IA7QA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;AAAA;AA7QA;;EAAA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA,kBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,kBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,mBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,iBA6QA;IA7QA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;AAAA;AA7QA;;EAAA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA;EA6QA;;EA7QA;IAAA,iBA6QA;IA7QA;EA6QA;AAAA;AA7QA;;EAAA;IAAA;EA6QA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n  background-color: var(--color-neutral-100); /* Default background color */\n}\n\n@layer base {\n  @font-face {\n    font-family: Roboto;\n    font-weight: 100;\n    src: url(/src/assets/fonts/roboto/roboto-100.ttf);\n  }\n  @font-face {\n    font-family: Roboto;\n    font-weight: 300;\n    src: url(/src/assets/fonts/roboto/roboto-300.ttf);\n  }\n  @font-face {\n    font-family: Roboto;\n    font-weight: 400;\n    src: url(/src/assets/fonts/roboto/roboto-400.ttf);\n  }\n  @font-face {\n    font-family: Roboto;\n    font-weight: 500;\n    src: url(/src/assets/fonts/roboto/roboto-500.ttf);\n  }\n  @font-face {\n    font-family: Roboto;\n    font-weight: 700;\n    src: url(/src/assets/fonts/roboto/roboto-700.ttf);\n  }\n  @font-face {\n    font-family: Roboto;\n    font-weight: 900;\n    src: url(/src/assets/fonts/roboto/roboto-900.ttf);\n  }\n  .about-content h1 {\n    @apply text-3xl;\n  }\n  .about-content h2 {\n    @apply text-2xl;\n  }\n  .about-content h3 {\n    @apply text-xl;\n  }\n  .about-content h4 {\n    @apply text-lg;\n  }\n  .about-content a {\n    @apply text-functional-info-400 no-underline hover:underline;\n  }\n  .about-content p {\n    @apply text-base;\n  }\n  .about-content u {\n    @apply underline;\n  }\n  .about-content s {\n    @apply line-through;\n  }\n  .about-content b {\n    @apply font-bold;\n  }\n  .about-content img {\n    @apply h-auto max-w-full rounded-lg;\n  }\n  .about-content table {\n    @apply w-full table-auto divide-y divide-neutral-300;\n  }\n  body {\n    @apply font-roboto text-neutral-600;\n  }\n\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  input[type='number'] {\n    -moz-appearance: textfield;\n  }\n}\n\n@layer components {\n  /* button styles */\n  .btn {\n    @apply flex items-center justify-center gap-2 rounded-lg text-sm font-medium leading-5;\n  }\n  .btn-size-small {\n    @apply py-[3px] px-3;\n  }\n  .btn-size-default {\n    @apply py-[6px] px-[10px];\n  }\n  .btn-size-large {\n    @apply py-[8px] px-[20px];\n  }\n  .btn-default {\n    @apply bg-transparent text-secondary-500 disabled:text-neutral-400 hover:bg-neutral-300 active:bg-neutral-200 hover:text-secondary-400 active:bg-neutral-300;\n  }\n  .btn-outlined {\n    @apply border border-neutral-400 hover:bg-neutral-200 hover:text-secondary-400 active:bg-neutral-300 bg-transparent text-neutral-500 disabled:border-neutral-300 disabled:text-neutral-400;\n  }\n  .btn-secondary {\n    @apply border border-transparent bg-secondary-500 text-neutral-100 hover:bg-secondary-400 active:bg-secondary-200 active:text-neutral-500 disabled:bg-neutral-300 disabled:text-neutral-400;\n  }\n  .btn-secondary-outlined {\n    @apply border border-secondary-500 text-secondary-500 hover:bg-secondary-400 hover:text-neutral-100 active:bg-secondary-500 active:text-neutral-100 disabled:bg-neutral-300 disabled:text-neutral-400;\n  }\n  .btn-primary {\n    @apply border border-transparent bg-primary-500 text-neutral-100 hover:bg-primary-400 active:bg-primary-200 active:text-neutral-500 disabled:bg-neutral-300 disabled:text-neutral-400;\n  }\n\n  /* tag styles */\n  .tag {\n    @apply inline-flex items-center justify-center gap-2 border border-transparent text-xs font-medium;\n  }\n  .tag-type-default {\n    @apply rounded-md px-1 py-[1px];\n  }\n  .tag-type-rounded {\n    @apply rounded-2xl px-2 py-[1px];\n  }\n\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  .sv-scrollbar::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n  .sv-scrollbar::-webkit-scrollbar-track {\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.1);\n  }\n  .sv-scrollbar::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.2);\n  }\n  .sv-scrollbar::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.4);\n  }\n  .sv-scrollbar::-webkit-scrollbar-thumb:active {\n    background: rgba(0, 0, 0, 0.9);\n  }\n  .tab-list-parent,\n  .active-tab {\n    @apply relative;\n  }\n  .tab-list-parent::after {\n    content: '';\n    @apply absolute left-0 bottom-0 h-[1px] w-full bg-neutral-300;\n  }\n  .tab-list-parent .active-tab::after {\n    content: '';\n    @apply absolute left-0 -bottom-[1px] z-10 w-full rounded-t-lg border-2 border-primary-500;\n  }\n  .nonactive-tab {\n    @apply neutral-button border-b-[1px] bg-secondary-100 text-neutral-500 rounded-t-lg px-3 py-2 md:px-4 md:py-2;\n  }\n\n  .transition-box {\n    max-width: 0;\n    overflow: hidden;\n    opacity: 0;\n    transform: translateX(-100%);\n    transition-property: max-width, transform, opacity;\n    transition-duration: 0.5s, 0s, 0.2s;\n    transition-timing-function: ease-out, ease-out, ease-out;\n    transition-delay: 0s, 0s, 0.3s;\n  }\n\n  .transition-box.active {\n    max-width: 25%;\n    transform: translateX(0);\n    opacity: 1;\n    transition-delay: 0.2s, 0s, 0s;\n  }\n\n  @media screen and (max-width: 480px) {\n    .transition-box.active {\n      max-width: 100%;\n    }\n  }\n\n  .neutral-button {\n    @apply transition-all duration-150 ease-in-out text-neutral-500 hover:bg-neutral-300 active:bg-secondary-500 active:text-neutral-100;\n  }\n\n  .tooltip {\n    @apply absolute w-fit hidden max-w-[250px] text-xs min-w-[50px] rounded bg-neutral-500 px-1 py-1 opacity-20 transition-opacity duration-100 ease-in-out group-hover:block group-hover:opacity-100;\n  }\n\n  .image-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 6px;\n    height: 50vh;\n    overflow-y: auto;\n    border-radius: 10px;\n  }\n\n  img.selected {\n    border: 8px solid #787878; /* A green border */\n    box-shadow: 0px 0px 20px 5px #787878; /* Horizontal, Vertical, Blur, Size and color */\n    transition:\n      box-shadow 0.3s ease-in-out,\n      border 0.3s ease-in-out; /* Smooth transition */\n    border-radius: 10px;\n  }\n\n  @layer components {\n    .table-container {\n      @apply overflow-x-auto pb-5 rounded-xl border border-neutral-300 bg-neutral-200 shadow shadow-neutral-300 w-full;\n    }\n\n    .table-container table {\n      @apply w-full min-w-[600px];\n    }\n\n    .table-container thead {\n      @apply bg-neutral-100 px-3;\n    }\n\n    .table-container thead tr {\n      @apply border-b-2 border-neutral-300;\n    }\n\n    .table-container thead th {\n      @apply text-left gap-1 text-neutral-600 p-2;\n    }\n\n    .table-container tbody tr {\n      @apply border-b border-neutral-100 hover:bg-secondary-100 px-3 py-2;\n    }\n    .table-container tbody td {\n      @apply p-2;\n    }\n  }\n\n  /* Styles for the scrollbar itself */\n  ::-webkit-scrollbar {\n    width: 7px; /* Adjust width of the scrollbar */\n  }\n  ::-webkit-scrollbar-horizontal {\n    height: 7px; /* Adjust height of the horizontal scrollbar */\n  }\n\n  /* Styles for the track (or progress bar) of the scrollbar */\n  ::-webkit-scrollbar-track {\n    background: var(--color-neutral-200); /* Color of the track */\n    border-radius: 10px; /* Roundness of the track */\n  }\n\n  /* Styles for the handle (or thumb) of the scrollbar */\n  ::-webkit-scrollbar-thumb {\n    background: var(--color-neutral-300); /* Color of the scrollbar handle */\n    border-radius: 10px; /* Roundness of the scrollbar handle */\n  }\n\n  input[type='date']::-webkit-calendar-picker-indicator {\n    background: url('https://www.svgrepo.com/show/191998/calendar.svg') no-repeat center center /\n      contain;\n    width: 35px;\n    height: 35px;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
